// extracted by mini-css-extract-plugin
export default {"individual":"Individual_individual__8ixiZ","company":"Individual_company__Ac29Y","detail":"Individual_detail__ctbe4"};